<template>
  <!-- <pre v-if="responseData"> testData={{ data }}</pre> -->
  <AdminBackground v-if="responseData">
    <div class="image-wrapper">
      <img
        src="@/assets/header/PASAR AWAM PBT.png"
        alt="PASAR AWAM PBT"
        class="pbt-image"
      >
      <!-- Center the line under the image -->
      <div class="line-under-image" />
    </div>
    <div class="content-wrapper">
      <h2>PROGRAM KAWALAN KEBERSIHAN PASAR AWAM PBT</h2>
      <div class="input-row">
        <div class="input-item">
          <AppAutocomplete
            v-model="selectedYear"
            label="Tahun"
            :items="years"
            placeholder="Pilih Tahun"
            chips
            class="app-date-picker"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedsState"
            label="Negeri"
            :items="states"
            placeholder="Pilih Negeri"
            chips
            multiple
            closable-chips
            class="app-date-picker"
            @update:model-value="handleStateChange"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedPbt"
            label="Pihak Berkuasa Tempatan"
            :items="pbt"
            placeholder="Pilih PBT"
            class="app-date-picker"
            chips
            multiple
            closable-chips
            @update:model-value="handleStateChange"
          />
        </div>
      </div>

      <h2>AKTIVITI PEMERIKSAAN PASAR AWAM PBT</h2>
      <div class="pasar">
        <div
          v-for="(activity, index) in pasarData"
          :key="index"
          class="pasar-container"
        >
          <img
            src="@/assets/spah/box.png"
            :alt="activity.altText"
            class="responsive-image"
          >
          <div class="text-overlay">
            <div class="values-layered">
              <h3>{{ activity.title }}</h3>
              <p class="number">
                {{ activity.count }}
              </p>
            </div>
          </div>
        </div>
      </div>
     

      <Update />
    </div>



    <div class="content-wrapper">   
      <h2>GRED PASAR</h2>
      <div class="chart-wrapper">
        <PasarBar 
          :chart-data="KelasChartData"
          :chart-categories="KelasChartNames"
          :series-colors="['#00c057', '#ffbf87', '#ff922e', '#f00000', ]"
        />
      </div>
    </div>
    <PrimaryModule />
    <KesihatanPersekitaran />
  </adminbackground>
</template>


<script setup>
import KesihatanPersekitaran from '@/components/menu-items/section-menu/kesihatan-persekitaran-menu.vue'
import { useHttpService } from "@/httpService"
import { computed, onMounted, ref } from 'vue'

const years = ref([])
const states = ref(["Semua Negeri"])
const pbt = ref([])
const councils = ref([])
const selectedYear = ref(2025)
const selectedsState = ref('Semua Negeri')
const selectedPbt = ref('Semua PBT')

const GredPasarData = ref([])
const GredPasarNames = ref([])

const KelasChartData = ref([])
const KelasChartNames = ref([])

//added by abdullah 
definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})


const pasar = ref({ 
  bilanganPasar: 0,
  bilanganGeraiPeniaga: 0,
  bilanganDigred: 0,
})


const pasarData = computed(() => [
  { title: 'Jumlah Pasar Awam Milik PBT', count: pasar.value.bilanganPasar, altText: 'First Image' },
  { title: 'Jumlah Perniaga', count: pasar.value.bilanganGeraiPeniaga, altText: 'Second Image' },
  { title: 'Bilangan Pasar Awam Diperiksa dan Digredkan', count: pasar.value.bilanganDigred, altText: 'Third Image' },
])

const data = ref({})

const { httpGet, numberWithCommas } = useHttpService()

const responseData = ref(null)

async function loadDataFromApi(year = selectedYear.value, state = selectedsState.value, pbtValue = selectedPbt.value) {
  try {

    // Ensure we're working with a plain array for states
    const plainStates = toRaw(state)

    // Create query parameters for year and states
    // Create the query parameters manually
    let queryParams = `year=${year}`
    console.log('Plain states:', plainStates)

    // Check if states are "Semua Negeri" and skip appending states[] if true
    if (!plainStates.includes("Semua Negeri")) {
      // Append each state to the query string with the desired 'states[]' format
      if (Array.isArray(plainStates)) {
        plainStates.forEach(state => {
          const stateName = typeof state === "string" ? state : state.name || state.value
          if (stateName) {
            queryParams += `&states[]=${encodeURIComponent(stateName)}`
          }
        })
      } else {
        queryParams += `&states[]=${encodeURIComponent(plainStates)}`
      }
    }

    // Append councils[] if pbtValue is selected
    if (Array.isArray(pbtValue) && !pbtValue.includes('Semua PBT')) {
      // Append each PBT in the array to the query parameters
      pbtValue.forEach(pbt => {
        queryParams += `&councils[]=${encodeURIComponent(pbt)}`
      })
    }

    // Construct the URL with the query parameters
    const url = `kesihatan-persekitaran/pasar-awam-pbt?${queryParams}`

    const response = await httpGet(url)

    years.value = response.years

    // Populate states dropdown while excluding "Modified Pbt" and null values
    states.value = ["Semua Negeri"]
    response.states.forEach(state => {
      if (state && state !== "Modified Pbt") {
        states.value.push(state)
      }
    })

    councils.value = response.councils
    responseData.value = response

    data.value = responseData.value.data.gred

    pasar.value = { 
      bilanganPasar: numberWithCommas(data.value.bilangan_pasar),
      bilanganGeraiPeniaga: numberWithCommas(data.value.bilangan_gerai_peniaga),
      bilanganDigred: numberWithCommas(data.value.bilangan_digred),
    }

    const kelas = responseData.value.data.gred

    // Filter and rename grades
    const filteredKelas = {
      "Gred A": kelas.gred_a,
      "Gred B": kelas.gred_b,
      "Gred C": kelas.gred_c,
      "Gred D": kelas.gred_d,
    }

    KelasChartNames.value = Object.keys(filteredKelas)
    KelasChartData.value = Object.values(filteredKelas)


  } catch (err) {
    console.error("loadDataFromApi failed:", err)
  }
}

function handleStateChange() {
  pbt.value = []

  // Ensure selectedsState and selectedPbt are arrays
  if (!Array.isArray(selectedsState.value)) {
    selectedsState.value = selectedsState.value ? [selectedsState.value] : []
  }
  if (!Array.isArray(selectedPbt.value)) {
    selectedPbt.value = selectedPbt.value ? [selectedPbt.value] : []
  }

  // Remove "Semua Negeri" if other states are selected
  if (selectedsState.value.includes("Semua Negeri") && selectedsState.value.length > 1) {
    selectedsState.value = selectedsState.value.filter(state => state !== "Semua Negeri")
  }

  // Remove "Semua PBT" if other PBTs are selected
  if (selectedPbt.value.includes("Semua PBT") && selectedPbt.value.length > 1) {
    selectedPbt.value = selectedPbt.value.filter(pbt => pbt !== "Semua PBT")
  }

  // If no states are selected, reset to "Semua Negeri"
  if (selectedsState.value.length === 0) {
    selectedsState.value = ["Semua Negeri"]
  }

  // If no PBTs are selected, reset to "Semua PBT"
  if (selectedPbt.value.length === 0) {
    selectedPbt.value = ["Semua PBT"]
  }

  if (selectedsState.value.includes("Semua Negeri")) {
    // Add all councils from all states
    Object.keys(councils.value).forEach(state => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach(councilKey => {
          const council = councils.value[state][councilKey]
          if (council && council.value) {
            pbt.value.push(council.value)
          }
        })
      }
    })
  } else {
    // Only add councils for the selected states
    selectedsState.value.forEach(state => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach(councilKey => {
          const council = councils.value[state][councilKey]
          if (council && council.value) {
            pbt.value.push(council.value)
          }
        })
      }
    })
  }

  console.log('Filtered PBT:', pbt.value)
}

onMounted(() => {
  loadDataFromApi()
  
})

//this is for setting the inital values for pbts as semua negeri id default option for Negeri (state) 
watch(councils, newValue => {
  if (newValue) handleStateChange()
}, { immediate: true })


watch([selectedYear, selectedsState, selectedPbt], () => {
  loadDataFromApi(selectedYear.value, selectedsState.value, selectedPbt.value)
}, { immediate: true })
</script>


<style scoped>
.content-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 65%); 
  border-radius: 20px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2); 
  margin: 20px 0;
}

.chart-wrapper {
  padding: 20px;
  border-radius: 10px;
  background: rgba(255, 254, 254, 80%);
  inline-size: 100%;
  max-inline-size: 1400px;
  margin-top: 40px;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  max-width: 70%; 
  height: auto;
}

.line-under-image {
  width: 70%; 
  height: 5px;
  background-color: white;
  border-radius: 5px;
  margin-top: 10px;
}

h2 {
  color: rgb(21,0,105);
  font-size: 1.5rem; 
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 10px; 
  text-align: left; 
  width: 100%;
}


/* Flexbox container for the input fields */
.input-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

/* Styles for each input field */
.input-item {
  flex: 1;
  margin-right: 15px;
}

/* Remove margin for the last item */
.input-item:last-child {
  margin-right: 0;
}


/* First row with two items */
.first-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* Two equal columns */
  gap: 20px;
  margin-bottom: 20px;
}

/* Second row with Gred A, B, and C */
.second-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* Three equal columns */
  gap: 20px;
}

.box {
  position: relative;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  height: 100px;
  transition: transform 0.3s;
}

.box:hover {
  transform: translateY(-5px);
}

.box p,
.box .count {
  color: white;
  font-weight: bold;
  text-align: center;
}

.box p {
  font-size: 1rem;
}

.box .count {
  font-size: 2rem;
}


.pasar {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 3 columns */
  grid-gap: 10px; /* Gap between the rows and columns */
}

.pasar-container {
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}


.responsive-image {
  width: 100%;
  height: auto;
  display: block;
}

.text-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-family: Arial, sans-serif;
  text-align: center; /* Centers the text horizontally */
}

.values-layered h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #150069;
  text-align: center;
}

.number {
  font-size: 24px;
  font-weight: bold;
  color: #a80000;
  text-align: center;
}

/* For larger screens, up to 1024px */
@media (max-width: 1024px) {
  .content-wrapper {
    padding: 15px;
  }

  h2 {
    font-size: 1.4rem;
  }

  .pasar {
    grid-template-columns: repeat(2, 1fr); /* Reduce to 2 columns */
    grid-gap: 15px;
  }

  .number {
    font-size: 1.8rem; /* Slightly smaller text */
  }
}

/* For medium screens, up to 768px */
@media (max-width: 768px) {
  .content-wrapper {
    padding: 10px;
  }

  h2 {
    font-size: 1.3rem;
  }

  .pasar {
    grid-template-columns: 1fr;
    grid-gap: 15px;
  }

  .number {
    font-size: 1.6rem;
  }
}

@media (max-width: 480px) {
  .content-wrapper {
    padding: 8px;
  }

  h2 {
    font-size: 1.1rem;
  }

  .pasar {
    grid-template-columns: 1fr; 
    grid-gap: 10px; 
  }

  .pasar-container {
    height: auto; 
    padding: 10px; 
    border-radius: 8px;
    margin-bottom: 10px;
  }

  .values-layered h3 {
    font-size: 0.9rem; 
    margin-bottom: 5px; 
  }

  .number {
    font-size: 1.2rem; 
    color: #a80000; 
  }
}
</style>
